import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { ApVendor } from 'src/app/classes/models';
import { ApVendorService } from 'src/app/services/ap-vendor.service';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-ap-vendors-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './ap-vendors-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ApVendorsGridComponent extends BaseGridComponent {
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private ApVendorService: ApVendorService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'ApVendor';
    this.rowModelType = 'serverSide';

    this.additionalQueryData = {
      attributes: ['id']
    };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.ApVendorService.getApVendors(queryObject),
          this.ApVendorService.getApVendorCount(countQueryObject)
        ]).subscribe({
          next: ([ApVendors, apVendorCount]: [ApVendor[], number]) => {
            params.success({
              rowData: ApVendors,
              rowCount: apVendorCount
            });
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
